export default __webpack_public_path__ + "static/3-66274b36e8f6196a584df48493815c63.jpeg";